// Module
var code = "<record-form-view fields=\"componentController.formFields\" model=\"componentController.model\" title=\"Change Progressive Definition\" on-submit=\"componentController.submit(formViewController)\" on-cancel=\"componentController.cancel(formViewController)\" show-buttons-at-top=\"true\"> </record-form-view> ";
// Exports
export default code;